import { Form } from "antd";
import { FormInstance } from "antd/lib";
import React from "react";

export const SyncFormToUrl: React.FC<{ form: FormInstance; onChange: ((v: any) => void) | undefined }> = ({
    form,
    onChange,
}) => {
    const formValues = Form.useWatch([], form);
    React.useEffect(() => {
        if (onChange && formValues) {
            onChange(formValues);
        }
    }, [formValues, onChange]);

    return null;
};
